/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Customer_Contract_Lapsed_NoticeInputs */



/**
* | output |
* | --- |
* | "This contract ended on {date} before it ever started. Contact oneAI to cancel it or to agree a new one." |
*
* @param {Partner_Customer_Contract_Lapsed_NoticeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customer_contract_lapsed_notice = /** @type {((inputs: Partner_Customer_Contract_Lapsed_NoticeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customer_Contract_Lapsed_NoticeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Dieser Vertrag endete am ${i?.date}, bevor er je begonnen hat. Wenden Sie sich an oneAI, um ihn zu stornieren oder einen neuen zu vereinbaren.`)
	return /** @type {LocalizedString} */ (`This contract ended on ${i?.date} before it ever started. Contact oneAI to cancel it or to agree a new one.`)
});